import { createReducer } from '@reduxjs/toolkit';

import getOrderStatistic from '../../thunks/statistic/getOrderStatistic';

const initialState = {
  loading: false,
  error: '',
  data: { labels: [], datasets: [] },
};

const getOrderStatisticReducer = createReducer(initialState, {
  [getOrderStatistic.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getOrderStatistic.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload?.labels ? payload : initialState.data,
  }),
  [getOrderStatistic.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: initialState.data,
  }),
});

export default getOrderStatisticReducer;
